import { Badge, Card, Col, Progress, Skeleton } from "antd";
import styles from "./CardCharts.module.scss";
import spacing from "../../ui/spacingConfig";
import { DashboardStatistics } from "../../../types/dashboardStatistics";
import { useMemo } from "react";

interface SubCard {
  label: string;
  count: number | string | undefined;
  color: string;
}
interface CardChartsProps {
  title: string;
  statistics: DashboardStatistics | undefined;
  type: "action" | "event";
  isFetching: boolean;
}

const CardCharts: React.FC<CardChartsProps> = ({
  title,
  statistics,
  type,
  isFetching,
}) => {
  const subCards: SubCard[] = useMemo(() => {
    if (type === "action") {
      return [
        {
          label: "Ã FAIRE",
          count: statistics?.actionsAffected || "?",
          color: "var(--yellow-1)",
        },
        { label: "EN RETARD", count: statistics?.actionsRetard, color: "var(--red-1)" },
        {
          label: "EN VALIDATION",
          count: statistics?.actionsPerformed,
          color: "var(--blue-5)",
        },
        {
          label: "VALIDEES",
          count: statistics?.actionsValidated,
          color: "var(--green-1)",
        },
      ];
    }
    return [
      {
        label: "Ã ATTRIBUER",
        count: statistics?.eventsDeclare,
        color: "var(--yellow-1)",
      },
      {
        label: "ATTRIBUES",
        count: statistics?.eventsDispatch,
        color: "var(--blue-6)",
      },
      {
        label: "EN COURS",
        count: statistics?.eventsTraitement,
        color: "var(--magenta)",
      },
      {
        label: "Ã VALIDER",
        count: statistics?.eventsDemandeValidation,
        color: "var(--blue-5)",
      },
      {
        label: "CLOTURES",
        count: statistics?.eventsCloture,
        color: "var(--green-1)",
      },
      {
        label: "EN RETARD",
        count: statistics?.eventsRetard,
        color: "var(--red-1)",
      },
    ];
  }, [statistics, type]);

  const terminatedPercentage = useMemo(() => {
    const s = statistics;

    if (!s) {
      return 0;
    }

    if (type === "action") {
      return (
        (s.actionsValidated /
          (s.actionsCreated + s.actionsAffected + s.actionsPerformed + s.actionsValidated)) *
        100
      );
    }

    return (
      (s.eventsCloture /
        ( s.eventsDispatch +
          s.eventsAnalyse +
          s.eventsTraitement +
          s.eventsDemandeValidation +
          s.eventsRefuse +
          s.eventsRetard +
          s.eventsCloture)) *
      100
    );
  }, [statistics, type]);

  return (
    <Col span={spacing.xs}>
      <Card title={title} className={styles.progressCard} bordered={false}>
        {isFetching ? (
          <Skeleton active />
        ) : (
          <div className={styles.progressCardContentContainer}>
            <div className={styles.progressStepsCardsContainer}>
              {subCards.map((subCard, index) => (
                <Card
                  key={index}
                  className={styles.progressStepCard}
                  bordered={false}
                >
                  <div className={styles.progressStepCardContent}>
                    <p>{subCard.label}</p>
                    <span>{subCard.count}</span>
                  </div>
                  <Badge
                    color={subCard.color}
                    className={styles.progressCardBadge}
                  />
                </Card>
              ))}
            </div>
            <div className={styles.progressCircle}>
              <Progress
                type="dashboard"
                percent={Math.round(terminatedPercentage)}
                strokeColor={"var(--blue-4)"}
                // trailColor="transparent"
                gapDegree={5}
              />
            </div>
          </div>
        )}
      </Card>
    </Col>
  );
};

export default CardCharts;
